import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router'
import templates from './modules/templates'
import forms from './modules/forms'
import { encryptParams, decryptParams } from '../utils/cryptojs_utils'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    idToken: null,
    refreshToken: null,
    accountId: null,
    accountName: 'Default',
    accounts: [],
    email: null,
    role: null,
    endDate: null,
    notifications: [],
    userId: null,
    selectedRoles: [],
    userRoleOrder: null,
    mode: null,
    refs: {},
    validationErrors: '',
    exportFormDocID: null,
    rotatedDocFormDocId: null,
    otherMedErrors: [],
    accountLogo: null,
    prevFormsTab: null,
    localTime: null,
    selectTriageStatus: [],
    selectAgentStatus: [],
    selectUnmatchStatus: [],
    selectEsfTriageStatus: [],
    loginLoading: false
  },
  mutations: {
    authUser (state, userData) {
      state.idToken = userData.idToken
      state.refreshToken = userData.refreshToken
      state.email = userData.email
      state.userId = userData.userId
      state.selectedRoles = userData.selectedRoles
      state.userRoleOrder = userData.userRoleOrder
    },
    logOut (state) {
      state.idToken = null
      state.refreshToken = null
      state.email = null
      state.role = null
      state.endDate = null
      state.userId = null
      state.accountId = null
    },
    setMetaData (state) {
      state.role = window.localStorage.getItem('role')
      state.refreshToken = window.localStorage.getItem('refreshToken')
      state.endDate = window.localStorage.getItem('endDate')
      state.accountId = parseInt(decryptParams(window.localStorage.getItem('accountId')))
      state.accountName = decryptParams(window.localStorage.getItem('accountName'))
      state.i18n.locale = window.localStorage.getItem('lang') || 'en'
      state.mode = window.localStorage.getItem('mode') || 'default'
      state.accountLogo = window.localStorage.getItem('accountLogo')
      const tab = window.localStorage.getItem('prevFormsTab')
      state.prevFormsTab = tab !== null && tab !== 'null' ? parseInt(tab) : null
      state.localTime = window.localStorage.getItem('localTime')
      state.selectTriageStatus = JSON.parse(window.localStorage.getItem('selectTriageStatus'))
      state.selectAgentStatus = JSON.parse(window.localStorage.getItem('selectAgentStatus'))
      state.selectUnmatchStatus = JSON.parse(window.localStorage.getItem('selectUnmatchStatus'))
      state.selectEsfTriageStatus = JSON.parse(window.localStorage.getItem('selectEsfTriageStatus'))
    },
    setToken (state, data) {
      window.localStorage.setItem('idToken', data.idToken)
      state.idToken = data.idToken
    },
    setNotification (state, userData) {
      if (userData.messages.length > 0) {
        state.notifications = userData.messages
      }
    },
    deleteNotification (state, index) {
      state.notifications.splice(index, 1)
    },
    setExportFormDocID (state, data) {
      window.localStorage.setItem('exportFormDocID', data)
      state.exportFormDocID = data
    },
    setRotatedDocFormDocId (state, data) {
      window.localStorage.setItem('rotatedDocFormDocId', data)
      state.rotatedDocFormDocId = data
    },
    setSelectedRoles (state, data) {
      state.selectedRoles = data
    },
    setUserRoleOrder (state, data) {
      state.userRoleOrder = data
    },
    setLocalTime (state, data) {
      window.localStorage.setItem('localTime', data)
      state.localTime = data
    },
    setPrevFormsTab (state, data) {
      window.localStorage.setItem('prevFormsTab', data)
      state.prevFormsTab = data
    },
    setselectTriageStatus (state, selectTriageStatus) {
      window.localStorage.setItem('selectTriageStatus', JSON.stringify(selectTriageStatus))
      state.selectTriageStatus = selectTriageStatus
    },
    setselectAgentStatus (state, selectAgentStatus) {
      window.localStorage.setItem('selectAgentStatus', JSON.stringify(selectAgentStatus))
      state.selectAgentStatus = selectAgentStatus
    },
    setselectUnmatchStatus (state, selectUnmatchStatus) {
      window.localStorage.setItem('selectUnmatchStatus', JSON.stringify(selectUnmatchStatus))
      state.selectUnmatchStatus = selectUnmatchStatus
    },
    setselectEsfTriageStatus (state, selectEsfTriageStatus) {
      window.localStorage.setItem('selectEsfTriageStatus', JSON.stringify(selectEsfTriageStatus))
      state.selectEsfTriageStatus = selectEsfTriageStatus
    },
    setValidationErrors (state, data) {
      window.localStorage.setItem('validationErrors', data)
      state.validationErrors = data
    },
    setRefs (state, data) {
      window.localStorage.setItem('refs', data)
      state.refs = data
    },
    setOtherMedErrors (state, data) {
      window.localStorage.setItem('otherMedErrors', data)
      state.otherMedErrors = data
    },
    setIsLoginLoading (state, data) {
      state.loginLoading = data.loginLoading
    }
  },
  actions: {
    // signUp ({commit}, signUpData) {
    //   let data = new window.FormData()
    //   data.append('username', signUpData.username)
    //   data.append('email', signUpData.email)
    //   data.append('password', signUpData.password)
    //   Vue.axios.post('users', data)
    //     .then(res => {
    //       Vue.toasted.show(this._vm.$i18n.translate('COMMON.MSG_SUCESS_ACC'))
    //       router.push('sign_in')
    //     })
    //     .catch(error => {
    //       Vue.toasted.show(this._vm.$i18n.translate('COMMON.MSG_SIGNUP_FAIL')),
    //         { icon: 'chain-broken', type: 'error' })
    //       console.log(error)
    //     })
    // },
    updateToken ({commit}, payload) {
      commit('setToken', {idToken: payload.token})
    },
    ssoLogin ({commit}, payload) {
      let data = new window.FormData()
      const {authData, redirectpath} = payload
      const {username, accessToken} = authData
      if (!(username && accessToken)) {
        throw new Error('Login Failed')
      }
      data.append('auth[ms_access_token]', accessToken)
      Vue.axios.post('azureAD', data, {headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': '0'
      }})
        .then(res => {
          if (res.data.status === 'created') {
            commit('authUser', {
              idToken: res.data.token.token,
              refreshToken: res.data.refresh_token,
              email: username,
              userId: res.data.user_id,
              selectedRoles: res.data.selected_roles,
              userRoleOrder: res.data.user_role_order
            })
            window.localStorage.setItem('idToken', res.data.token.token)
            window.localStorage.setItem('refreshToken', res.data.refresh_token)
            window.localStorage.setItem('accountId', encryptParams(res.data.account_id))
            window.localStorage.setItem('accountName', encryptParams(res.data.account_name))
            window.localStorage.setItem('role', res.data.role)
            window.localStorage.setItem('endDate', res.data.end_date)
            window.localStorage.setItem('email', encryptParams(username))
            window.localStorage.setItem('userId', res.data.user_id)
            window.localStorage.setItem('selectedRoles', JSON.stringify(res.data.selected_roles))
            window.localStorage.setItem('userRoleOrder', res.data.user_role_order)
            window.localStorage.setItem('mode', 'default')
            window.localStorage.setItem('accountLogo', res.data.account_logo)
            window.localStorage.setItem('localTime', res.data.local)
            commit('setMetaData')
            Vue.toasted.show(this._vm.$i18n.translate('COMMON.MSG_LOGIN_SUCESS') + username,
              { icon: 'user-circle', type: 'success' })
          } else {
            Vue.toasted.show(res.data.msg, { icon: 'user-times', type: 'error' })
          }
          if (redirectpath) {
            router.push(redirectpath)
          } else {
            router.push('/process/processed')
          }
        })
        .catch(error => {
          if (error && error.status === 404) {
            console.log('Unauthorized, Do nothing')
            Vue.toasted.show(this._vm.$i18n.translate('COMMON.MSG_USER_NF'), { icon: 'user-times', type: 'error' })
          } else {
            Vue.toasted.show(this._vm.$i18n.translate('COMMON.MSG_LOGIN_FAIL'), { icon: 'chain-broken', type: 'error' })
            router.replace('sign_in')
          }
        })
    },
    logIn ({commit}, payload) {
      commit('setIsLoginLoading', {loginLoading: true})
      const {authData, redirectpath} = payload
      let data = new window.FormData()
      data.append('auth[email]', authData.email)
      data.append('auth[password]', authData.password)
      Vue.axios.post('user_token', data, {headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': '0'
      }})
        .then(res => {
          commit('setIsLoginLoading', {loginLoading: false})
          if (res.data.status === 'created') {
            commit('authUser', {
              idToken: res.data.token.token,
              refreshToken: res.data.refresh_token,
              email: authData.email,
              userId: res.data.user_id,
              selectedRoles: res.data.selected_roles,
              userRoleOrder: res.data.user_role_order
            })
            window.localStorage.setItem('idToken', res.data.token.token)
            window.localStorage.setItem('refreshToken', res.data.refresh_token)
            window.localStorage.setItem('accountId', encryptParams(res.data.account_id))
            window.localStorage.setItem('accountName', encryptParams(res.data.account_name))
            window.localStorage.setItem('role', res.data.role)
            window.localStorage.setItem('endDate', res.data.end_date)
            window.localStorage.setItem('email', encryptParams(authData.email))
            window.localStorage.setItem('userId', res.data.user_id)
            window.localStorage.setItem('selectedRoles', JSON.stringify(res.data.selected_roles))
            window.localStorage.setItem('userRoleOrder', res.data.user_role_order)
            window.localStorage.setItem('mode', 'default')
            window.localStorage.setItem('accountLogo', res.data.account_logo)
            window.localStorage.setItem('localTime', res.data.local)
            commit('setMetaData')
            Vue.toasted.show(this._vm.$i18n.translate('COMMON.MSG_LOGIN_SUCESS') + authData.email,
              { icon: 'user-circle', type: 'success' })
            if (res.data.account_id === 73) {
              router.push('/medical_insurance_cards/demo')
            } else {
              if (redirectpath) {
                router.push(redirectpath)
              } else {
                router.push('/process/processed')
              }
            }
          } else {
            Vue.toasted.show(res.data.msg, { icon: 'user-times', type: 'error' })
          }
        })
        .catch(error => {
          commit('setIsLoginLoading', {loginLoading: false})
          if (error && error.status === 404) {
            console.log('Unauthorized, Do nothing')
            Vue.toasted.show(this._vm.$i18n.translate('COMMON.MSG_USER_NF'), { icon: 'user-times', type: 'error' })
          } else if (error && error.status === 503) {
            Vue.toasted.show(this._vm.$i18n.translate('COMMON.MSG_SERVER_UA'), { icon: 'user-times', type: 'error' })
          } else {
            Vue.toasted.show(this._vm.$i18n.translate('COMMON.MSG_LOGIN_FAIL'), { icon: 'chain-broken', type: 'error' })
            router.replace('sign_in')
          }
        })
    },
    autoLogin ({commit}) {
      const token = window.localStorage.getItem('idToken')
      const email = window.localStorage.getItem('email')
      const decryptedEmail = email ? decryptParams(email) : email
      const userId = window.localStorage.getItem('userId')
      const selectedRoles = JSON.parse(window.localStorage.getItem('selectedRoles'))
      const userRoleOrder = window.localStorage.getItem('userRoleOrder')
      if (!token) { return }
      commit('authUser', {
        idToken: token,
        email: decryptedEmail,
        userId: userId,
        selectedRoles: selectedRoles,
        userRoleOrder: userRoleOrder
      })
    },
    updateNotification ({commit, rootState}, state) {
      Vue.axios.get('/notifications/', { headers: { Authorization: `Bearer ${rootState.idToken}` } })
        .then(res => {
          commit('setNotification', {
            messages: res.data
          })
        })
        .catch(error => {
          if (error.status === 401) {
            return this.getters.appMode === 'default' ? router.replace('/sign_in') : ''
          } else {
            Vue.toasted.show(this._vm.$i18n.translate('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    logOut ({commit}) {
      Vue.axios.get('/users/logout', {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem('idToken')}`,
          'Cache-Control': 'no-cache, no-store',
          'Pragma': 'no-cache',
          'Expires': '0'
        }
      })
        .then(res => console.log('Successfully logged out'))
        .catch(err => console.log(err))
      commit('logOut')
      window.localStorage.clear()
      window.localStorage.setItem('logout-event', Date.now())
      Vue.toasted.show(this._vm.$i18n.translate('COMMON.MSG_LOGOUT'),
        { icon: 'hand-stop-o', type: 'success' })
      router.replace('/log_in')
    },
    setMetaData ({commit}) {
      commit('setMetaData')
    }
  },
  getters: {
    isAuthenticated: state => {
      return state.idToken !== null
    },
    currentUserEmail: state => {
      return state.email
    },
    currentUserId: state => {
      return state.userId
    },
    refs: state => {
      return state.refs
    },
    exportFormDocID: state => {
      return state.exportFormDocID
    },
    rotatedDocFormDocId: state => {
      return state.rotatedDocFormDocId
    },
    idToken: state => {
      return state.idToken
    },
    refreshToken: state => {
      return state.refreshToken
    },
    accountId: state => {
      return state.accountId
    },
    accountName: state => {
      return state.accountName
    },
    isSuperAdmin: state => {
      return state.role === 'super admin'
    },
    isAdmin: state => {
      return state.role === 'admin'
    },
    isAgent: state => {
      return state.role === 'agent'
    },
    trialUser: state => {
      return state.role === 'trial user'
    },
    userRole: state => {
      return state.role
    },
    endDate: state => {
      return state.endDate
    },
    selectedRolesData: state => {
      return state.selectedRoles
    },
    userRoleOrder: state => {
      return state.userRoleOrder
    },
    isAdminRole: state => {
      return (state.role === 'super admin' || state.role === 'admin')
    },
    appMode: state => {
      return state.mode
    },
    accountLogo: state => {
      return state.accountLogo
    },
    prevFormsTab: state => {
      return state.prevFormsTab
    },
    selectTriageStatus: state => {
      return state.selectTriageStatus
    },
    selectAgentStatus: state => {
      return state.selectAgentStatus
    },
    selectUnmatchStatus: state => {
      return state.selectUnmatchStatus
    },
    selectEsfTriageStatus: state => {
      return state.selectEsfTriageStatus
    },
    localTime: state => {
      return state.localTime
    },
    otherMedErrors: state => {
      return state.otherMedErrors
    },
    isLoginLoading: state => {
      return state.loginLoading
    }
  },
  modules: {
    templates,
    forms
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js